export default "__VITE_ASSET__AwmQ0eoe__"